import { render } from "./Empresa.vue?vue&type=template&id=5799b098"
import script from "./Empresa.vue?vue&type=script&lang=js"
export * from "./Empresa.vue?vue&type=script&lang=js"
script.render = render

export default script